<template>
    <card bg="bg-dark text-white" title="Muestras Solicitadas">
        <div v-if="details.length > 0" style="height: 40px; width: 100%">
            <span style="float: right">
                <button :disabled="btnDisabled" class="btn btn-success" @click="dispatch">
                    <i class="fas fa-truck"></i>
                    Despachar {{ buttonText }}
                </button>
            </span>
        </div>
        <div class="card mt-4">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Servicio de Transporte</label>
                            <v-select v-model="courier" :class="courierMessage ? 'is-invalid-select' : ''"
                                :options="couriers" @input="validButton">
                                <span slot="no-options">No se encontraron Courier</span>
                            </v-select>
                            <div class="text-danger small text-right">
                                {{ courierMessage }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 no-internal">
                        <label>N° Seguimiento</label>
                        <input v-model="trackingNumber" :class="'form-control ' + (trackingMessage ? 'is-invalid' : '')"
                            type="text" @input="validButton" />
                        <div class="text-danger small text-right">
                            {{ trackingMessage }}
                        </div>
                    </div>
                    <div class="col-md-2 no-internal">
                        <label>N° Guía</label>
                        <input v-model="transportDispatchGuide" :class="'form-control ' + (dispacthGuideMessage ? 'is-invalid' : '')
                            " type="text" @input="validButton" />
                        <div class="text-danger small text-right">
                            {{ dispacthGuideMessage }}
                        </div>
                    </div>
                    <div class="col-md-2">
                        <label>Fecha de envío</label>
                        <input v-model="shippingDate" :class="'form-control ' + (shippingDateMessage ? 'is-invalid' : '')
                            " :min="minDate" type="date" @input="validButton" />
                        <div class="text-danger small text-right">
                            {{ shippingDateMessage }}
                        </div>
                    </div>
                    <div class="col-md-2">
                        <label>Fecha estimada de entrega</label>
                        <input v-model="eta" :class="'form-control ' + (etaMessage ? 'is-invalid' : '')"
                            :min="minDateArrived" type="date" @input="validButton" />
                        <div class="text-danger small text-right">{{ etaMessage }}</div>
                    </div>
                </div>
            </div>
        </div>
        <card v-if="detailNew.length > 0" title="Nuevo Producto">
            <div class="table-responsive">
                <div v-for="item in detailNew" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-12">
									<h5 class="card-title d-inline"><b>VINO: {{ item.variety }}
                                        {{ item.valley }} {{ item.quality }}</b></h5>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
								</div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode" style="width: 20%">
                                                    Mezcla Comercial
                                                </th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} - {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
													<span class="badge badge-info p-2">{{ item.variety }}</span> 
																										<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table
                                        class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                            v-if="item.estimatedDeliveryDateOenology
                                            || item.deliveryDateOenology
                                            || item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"
                                        >
                                        <tr class="thead-dark">
                                            <th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology">Entrega Enología</th>
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validacion de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.estimatedDeliveryDateOenology">
                                                <span class="badge badge-warning" style="font-size: 16px">{{
                                                    item.estimatedDeliveryDateOenologyString }}</span>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.deliveryDateOenologyString }}</span>
                                            </td>
                                            <td v-if="item.wineryValidatedAt">
                                                <span  class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.wineryDispatchString }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.status == 'Desp. Rechazado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de rechazo:</b>
                                        {{ item.rejectionReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Capsula</th>
                                                <td>{{ item.capsuleName }} - {{ item.capsuleCode }}</td>
                                            </tr>
                                            <tr>
                                                <th>Tapa</th>
                                                <td>{{ item.cappingName }} - {{ item.cappingCode }}</td>
                                            </tr>
                                            <tr>
                                                <th>Caja</th>
                                                <td>{{ item.boxName }} - {{ item.boxCode }}</td>
                                            </tr>
                                            <tr>
                                                <th>Botella</th>
                                                <td>{{ item.bottleName }} - {{ item.bottleCode }}</td>
                                            </tr>
                                            <tr>
                                                <th>Etiqueta</th>
                                                <td>{{ item.labelName }} - {{ item.labelCode }}</td>
                                            </tr>
                                            <tr>
                                                <th>Contraetiqueta</th>
                                                <td>
                                                    {{ item.backLabelName }} - {{ item.backLabelCode }}
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div v-if="item.isNewComposition == true" class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="2">
                                                    Nueva Composición
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Variedad</th>
                                                <th>Porcentaje</th>
                                            </tr>
                                            <tr v-for="composition in item.compositionDetails" :key="composition.id">
                                                <td v-if="item.id ===
                                                    composition.requestCommercialSampleDetailID
                                                    ">
                                                    {{ composition.variety }}
                                                </td>
                                                <td v-if="item.id ===
                                                    composition.requestCommercialSampleDetailID
                                                    ">
                                                    {{ composition.percent }}%
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
										</tbody>
									</table>
								</div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <card v-if="detailFinish.length > 0" title="Producto Terminado">
            <div v-if="detailFinish.length > 0" class="table-responsive">
                <div v-for="item in detailFinish" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-12">
									<h5 class="card-title d-inline"><b>SKU: {{ item.sku }}</b></h5>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Sku</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode" style="width: 20%">
                                                    Mezcla Comercial
                                                </th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} -   {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span> 
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Sku (Para Despacho)</th>
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Vino No Real</th>
                                            <th>No Maquetar</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalSku }}</span>
                                            </td>
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
                                                <i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notRealWine" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notRealWine" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notLayout" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notLayout" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                        v-if="item.estimatedDeliveryDateOenology
                                            || item.deliveryDateOenology
                                            || item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"    
                                        >
                                        <tr class="thead-dark">
                                            <th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology">Entrega Enología</th>
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validación de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.estimatedDeliveryDateOenology">
                                                <span class="badge badge-warning" style="font-size: 16px">{{
                                                    item.estimatedDeliveryDateOenologyString
                                                }}</span>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.deliveryDateOenologyString
                                                }}</span>
                                            </td>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryDispatchString
                                                }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide
                                                }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.status == 'Desp. Rechazado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de rechazo:</b>
                                        {{ item.rejectionReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Componentes</th>
                                            </tr>
                                            <tr v-if="item.saleZoneCode != null">
                                                <th>
                                                    Zona de venta:
                                                    <span class="ml-2">{{ item.saleZone }}</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tr v-for="lc in item.components" :key="lc.id">
                                            <td v-if="lc.requestCommercialSampleDetailId === item.id">
                                                {{ lc.name }}
                                            </td>
                                        </tr>
                                        <tr style="color: white; background-color: #6c757d">
                                            <td>
                                                <span class="mr-4">Semielaborado:</span>
                                                {{ item.semiElaborateName }} -
                                                {{ item.semiElaborateCode }}
                                            </td>
                                        </tr>
                                        <tr v-if="item.otherSemiElaborateCode" style="color: white; background-color: #6c757d">
                                            <td colspan="2"><span class="mr-4">Otro Semielaborado:</span></td>
                                        </tr>
                                        <tr v-if="item.otherSemiElaborateCode">
                                            <td>{{ item.otherSemiElaborateCode }}</td>
                                            <td>{{ item.otherSemiElaborateName }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
										</tbody>
									</table>
								</div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <alert v-else message="Aún no se registran muestras" />
        </card>
        <card v-if="detailBottle.length > 0" title="Producto Guarda Botella">
            <div class="table-responsive">
                <div v-for="item in detailBottle" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-12">
									<h5 class="card-title d-inline"><b>CÓDIGO: {{ item.sku }}</b></h5>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
								</div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Código</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode" style="width: 20%">
                                                    Mezcla Comercial
                                                </th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td><span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">{{ item.comercialMix }} - {{ item.comercialMixCode }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span> 
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
                                                <i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                        v-if="item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"  
                                        >
                                        <tr class="thead-dark">
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validación de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryDispatchString
                                                }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide
                                                }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.status == 'Desp. Rechazado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de rechazo:</b>
                                        {{ item.rejectionReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr v-if="item.capsuleName">
                                                <th>Capsula</th>
                                                <td>{{ item.capsuleName }} - {{ item.capsuleCode }}</td>
                                            </tr>
                                            <tr v-if="item.cappingName">
                                                <th>Tapa</th>
                                                <td>{{ item.cappingName }} - {{ item.cappingCode }}</td>
                                            </tr>
                                            <tr v-if="item.boxName">
                                                <th>Caja</th>
                                                <td>{{ item.boxName }} - {{ item.boxCode }}</td>
                                            </tr>
                                            <tr v-if="item.bottleName">
                                                <th>Botella</th>
                                                <td>{{ item.bottleName }} - {{ item.bottleCode }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations" :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
    </card>
</template>
<script>
//import toastr from "toastr";
import { Get, Post, Put } from "../../../helper/axios";
import $ from "jquery";

export default {
    props: ["details", "id", "component", "progressDispatch", "minDate"],
    data() {
        return {
            Put,
            Get,
            Post,
            apiUrl: this.$store.getters.apiUrl,
            detailId: 0,
            listSelectSample: [],
            exist: false,
            updateDispatch: {},
            rejectionReason: "",
            trackingNumber: "",
            shippingDate: "",
            couriers: [],
            courier: {},
            eta: "",
            btnDisabled: true,
            url: "",
            existEta: "",
            existShippingDate: "",
            validDispatch: false,
            minDateArrived: "",
            transportDispatchGuide: "",
        };
    },
    created() {
        this.minDateArrived = this.minDate;
        this.getCourier();
    },
    methods: {
        dispatch() {
            this.getUrl();
            this.validDispatch = false;
            var query = "c=" + this.courier.label + ";" + "n=" + this.trackingNumber;
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/trackings/" + query, (res) => {
                this.$store.commit("setLoading", false);
                if (res.data != "") {
                    this.existEta = res.data.estimatedArrivedDateAtString
                        .split("-")
                        .reverse()
                        .join("-");
                    this.existShippingDate = res.data.shippingDateCourierString
                        .split("-")
                        .reverse()
                        .join("-");
                    if (this.existEta != "" && this.existShippingDate != "") {
                        if (
                            this.existEta != this.eta &&
                            this.existShippingDate != this.shippingDate
                        ) {
                            this.$swal({
                                title:
                                    "El Servicio de Transporte y N° Seguimiento estan registrados",
                                html: "</br><h5>El Servicio de Transporte y N° Seguimiento ya tiene registro pero las fechas no coinciden</h5><h4>¿Desea que se complete con las fechas ya registradas?</h4>",
                                icon: "info",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                            }).then((result) => {
                                if (result.value) {
                                    this.eta = this.existEta;
                                    this.shippingDate = this.existShippingDate;
                                    this.validDispatch = true;
                                }
                            });
                        } else this.validDispatch = true;
                        this.existEta = "";
                        this.existShippingDate = "";
                    } else this.validDispatch = true;
                } else this.validDispatch = true;

                if (this.validDispatch == true) {
                    this.$swal({
                        title: "¿Desea Despachar " + this.buttonText + "?",
                        html:
                            "</br><h5>Datos a registrar</h5><table class='text-left'><tr><th>Servicio de Transporte: </th><td> " +
                            this.courier.label +
                            "</td></tr><tr><th>N° Seguimiento: </th><td> " +
                            this.trackingNumber +
                            "</td></tr><tr><th>N° Guía: </th><td> " +
                            this.transportDispatchGuide +
                            "</td></tr><tr><th>Fecha de envío: </th><td> " +
                            this.shippingDate +
                            "</td></tr><tr><th>Fecha estimada de entrega: </th><td> " +
                            this.eta +
                            "</td></tr></table></br>",
                        icon: "info",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                    }).then((result) => {
                        if (result.value) {
                            this.updateDispatch = {
                                action: "Dispatch",
                                list: this.listSelectSample,
                            };

                            if (this.listSelectSample.length == 0) {
                                this.details.forEach((element) => {
                                    if (
                                        element.rejectAt == null &&
                                        element.dispatchedAt == null
                                    ) {
                                        this.listSelectSample.push(element.id);
                                    }
                                });
                            }
                            this.$store.commit("setLoading", true);
                            let data = {
                                trackingNumber: this.trackingNumber,
                                courier: this.courier.label,
                                internal: this.courier.internal,
                                requestCommercialSampleDetailList: this.listSelectSample,
                                trackingUrl: this.url + this.trackingNumber,
                                estimatedArrivedDateAt: this.eta,
                                ShippingDateCourier: this.shippingDate,
                                transportDispatchGuide: this.transportDispatchGuide,
                            };

                            this.Post(`${this.apiUrl}v1/trackings/`, data, () => {
                                this.$store.commit("setLoading", false);
                                this.listSelectSample = [];
                                window.toastr.success(
                                    "Se ha realizado el despacho correctamente."
                                );
                                this.validDispatch = false;
                                //this.$router.push("/");
                                location.reload();
                            });
                            this.validDispatch = false;
                        }
                    });
                }
                this.updateDispatch = {};
            });
        },
        validButton() {
            if (this.shippingDate != "") this.minDateArrived = this.shippingDate;
            else this.minDateArrived = this.minDate;

            this.btnDisabled = true;

            if (this.courier) {
                if (!this.courier.internal) {
                    $(".no-internal").show();
                    if (
                        this.isValid &&
                        this.trackingNumber != "" &&
                        this.transportDispatchGuide != "" &&
                        this.courier &&
                        this.shippingDate != "" &&
                        this.courier.label != "" &&
                        this.eta != ""
                    )
                        this.btnDisabled = false;
                }
                if (this.courier.internal) {
                    $(".no-internal").hide();
                    if (
                        this.isValid &&
                        this.shippingDate != "" &&
                        this.courier.label != "" &&
                        this.eta != ""
                    )
                        this.btnDisabled = false;
                }
            }
        },
        getCourier() {
            this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/courier/`, (res) => {
                this.couriers = [];
                res.data.data.forEach((item) => {
                    this.couriers.push({
                        code: item.id,
                        label: item.name,
                        internal: item.internal,
                    });
                });
                this.courier = this.couriers[0]; //Send Default Hot Express
                this.$store.commit("setLoading", false);
            });
        },
        SampleList(id) {
            for (var i = 0; i < this.listSelectSample.length; i++) {
                if (this.listSelectSample[i] === id) {
                    this.listSelectSample.splice(i, 1);
                    this.exist = true;
                }
            }

            if (this.exist == false) {
                this.listSelectSample.push(id);
            }
            this.exist = false;
        },
        getRequest() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/requestsamples/", (res) => {
                this.requests = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        getUrl() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/courier/" + this.courier.code, (res) => {
                this.url = res.data[0].url;
                this.$store.commit("setLoading", false);
            });
            this.validButton();
        },
        ChangeIconCollapse(item) {
            if ($("#icon" + item).hasClass("fa-angle-down")) {
                $("#icon" + item).toggleClass("fa-angle-up");
            } else if ($("#icon" + item).hasClass("fa-angle-up")) {
                $("#icon" + item).toggleClass("fa-angle-down");
            }
        },
        downloadFile(id) {
            window.open(`${this.apiUrl}v1/documentfile/${id}`);
        },
    },
    computed: {
        detailNew: function () {
            return this.details.filter((x) => x.requestTypeId === 1);
        },
        detailFinish: function () {
            return this.details.filter((x) => x.requestTypeId === 2);
        },
        detailBottle: function () {
            return this.details.filter((x) => x.requestTypeId === 3);
        },
        buttonText() {
            return this.listSelectSample == 0 ? "Todo" : "Selección";
        },
        courierMessage() {
            let message = "";
            if (!this.courier) message = "Seleccione Courier";
            return message;
        },
        trackingMessage() {
            let message = "";
            if (!this.trackingNumber) message = "Ingrese N° Seguimiento";
            return message;
        },
        shippingDateMessage() {
            let message = "";
            if (!this.shippingDate) message = "Ingrese fecha de envío";
            return message;
        },
        etaMessage() {
            let message = "";
            if (!this.eta) message = "Ingrese fecha estimada de entrega";
            return message;
        },
        dispacthGuideMessage() {
            let message = "";
            if (!this.transportDispatchGuide) message = "Ingrese N° Guía de entrega";
            return message;
        },
        isValid() {
            if (this.courier.internal) {
                return (
                    !this.courierMessage && !this.etaMessage && !this.shippingDateMessage
                );
            }
            return (
                !this.courierMessage &&
                !this.trackingMessage &&
                !this.etaMessage &&
                !this.shippingDateMessage &&
                !this.dispacthGuideMessage
            );
        },
    },
};
</script>
